import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  Drawer,
  Box,
} from "@mui/material";
import axios from "axios";
import { FaAlignJustify } from "react-icons/fa";
import { LOGOUT_URL } from "../utils";

const Navbar = () => {
  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  useEffect(() => {
    setActiveLink(window.location.pathname);
  }, [window.location.pathname]);

  const logoutRequest = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.get(LOGOUT_URL, {
        headers: { Authorization: `${token}` },
      });
    } catch (error) {
      console.error(error);
    } finally {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
  };

  const handleMenuToggle = () => setIsMenuOpen(!isMenuOpen);

  const navLinks = [
    { text: "Home", path: "/" },
    { text: "Videos", path: "/videos" },
    { text: "Track Order", path: "/track" },
  ];

  return (
    <AppBar
      position="static"
      sx={{
        backgroundColor: "#fff",
        padding: 2,
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        {/* Logo */}
        <Typography
          variant="h6"
          component="div"
          color="#D4A256"
          sx={{ display: "flex", alignItems: "center", fontWeight: 700 }}
        >
          <img
            src="/favicon.ico"
            alt="Logo"
            style={{ width: "100px", marginRight: "10px", fontFamily: "cursive" }}
          />
          e Digital Creative Studio
        </Typography>

        {/* Mobile Menu Button */}
        <IconButton
          color="inherit"
          aria-label="open drawer"
          edge="end"
          onClick={handleMenuToggle}
          sx={{ display: { xs: "block", md: "none" } }}
        >
          <FaAlignJustify color="#d4a256" />
        </IconButton>

        {/* Desktop Navigation Links */}
        <Box sx={{ display: { xs: "none", md: "flex" }, gap: "1.5rem" }}>
          {navLinks?.map((link) => (
            <Link
              key={link.text}
              to={link.path}
              style={{
                textDecoration: "none",
                color: activeLink === link.path ? "#d4a256" : "#000",
                fontWeight: "bold",
              }}
              onClick={() => setActiveLink(link.path)}
            >
              {link.text}
            </Link>
          ))}
          {isLoggedIn && (
            <>
              <Link
                to="/orders"
                style={{
                  textDecoration: "none",
                  color: activeLink === "/orders" ? "#d4a256" : "#000",
                  fontWeight: "bold",
                }}
                onClick={() => setActiveLink("/orders")}
              >
                Dashboard
              </Link>
              <Link
                style={{
                  textDecoration: "none",
                  color: "#000",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  const res = window.confirm("Do you want to logout ?");
                  if (res) {
                    logoutRequest();
                  } else {
                  }
                }}
              >
                Logout
              </Link>
            </>
          )}
        </Box>
      </Toolbar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={isMenuOpen}
        onClose={handleMenuToggle}
        sx={{
          "& .MuiDrawer-paper": { width: "250px", backgroundColor: "#fdf2f2" },
        }}
      >
        <List>
          {navLinks.map((link) => (
            <ListItem
              button
              key={link.text}
              component={Link}
              to={link.path}
              onClick={() => {
                setActiveLink(link.path);
                handleMenuToggle();
              }}
            >
              <ListItemText
                primary={link.text}
                sx={{ color: activeLink === link.path ? "#d4a256" : "#000" }}
              />
            </ListItem>
          ))}
          {isLoggedIn && (
            <>
              <ListItem
                key={'Dashbaord'}
                component={Link}
                to={'/orders'}
                onClick={() => setActiveLink("/orders")}
              >
                Dashboard
              </ListItem>
              <ListItem
                style={{
                  textDecoration: "none",
                  color: "#000",
                  fontWeight: "bold",
                }}
                onClick={() => {
                  const res = window.confirm("Do you want to logout ?");
                  if (res) {
                    logoutRequest();
                  } else {
                  }
                }}
              >
                Logout
              </ListItem>
            </>
          )}
        </List>
      </Drawer>
    </AppBar>
  );
};

export default Navbar;
